class MilestoneDuration {
    constructor(
        $scope,
        milestonesService
    ) {
        this.getList = (list) => {
            return milestonesService.getList(this.milestone.type + list);
        }
    }
}

tenderEdit.component('milestoneDuration', {
    templateUrl: '/static/scripts/modules/TenderEdit/views/components/milestone-duration.html',
    controller: MilestoneDuration,
    controllerAs: 'vm',
    bindings: {
        id: '@',
        label: '@',
        ngModel: '=',
        milestone: '<',
        ngDisabled: '<',
        ngRequired: '<',
    }
});
